import { useCallback, useState } from "react";
import { TableListButton } from "../Misc/Buttons/TableListButton";
import style from "./ReportConfigCard.module.scss"
import { Button } from "../Misc/Buttons/Button";
import { CardContainer } from "./CardContainer";
import { useTranslation } from "react-i18next"
import { ReportConfig } from "../../types/types";
import { Requester } from "../../utils/Requester";
import toast from "react-hot-toast";
import loadingImage from "../../images/loading-indicator.svg"

interface Props {
  reportConfigs?: Array<ReportConfig>;
  openModal: (config?: ReportConfig) => void;
  handleDownload: (params: Array<string>) => Promise<void> | undefined;
  refreshConfigs: () => void;
}

interface ButtonProps {
  onClick: () => Promise<void> | undefined
  children: string,
}

function GenerateReportButton({
  onClick,
  children,
}: ButtonProps) {
  const [loading, setLoading] = useState(false)

  const onClickWrapper = useCallback(() => {
    const request = onClick();
    if (request) { // request pending, disable button for loading
      setLoading(true)
      request.finally(() => { setLoading(false) })
    }
  }, [onClick])

  if (loading) {
    return <Button disabled onClick={() => {}}>
      {children}{" "}
      <img src={loadingImage} alt="" />
    </Button>
  } else {
    return <Button onClick={onClickWrapper}>{children}</Button>
  }
}

export function ReportConfigCards({
  reportConfigs,
  openModal,
  handleDownload,
  refreshConfigs,
}: Props) {
  const { t } = useTranslation();

  const handleDelete = (configId: number) => {
    Requester.deleteReportConfig(configId)
      .then(() => {
        toast.success(t("Configuration deleted!"));
        refreshConfigs();
      })
  };

  return <>
    <CardContainer
      onClick={() => { openModal() }}
    >
      <div
        className={style.createNewConfig}>
        <i
          className="fa-solid fa-plus"
          style={{ margin: "0.5rem", fontSize: "2rem" }}
        />
        <p>{t("Create a new report configuration")}</p>
      </div>
    </CardContainer>
    {reportConfigs?.map((config) => (
      <CardContainer>
        <div className={style.cardTitle}>
          <p>{config.name}</p>
        </div>
        <hr />
        <div className={style.buttonContainer}>
          {/* is there a better way to make the button use all available space? */}
          <div className={style.generateButton}>
            <GenerateReportButton onClick={() => { return handleDownload(config.chart_params) }}>
              {t("Generate Report")}
            </GenerateReportButton>
          </div>
          <div className={style.tableListButtons}>
            <TableListButton
              onClick={() => { openModal(config) }}
              title=""
              large
            >
              <i className="fa-solid fa-pen" style={{ fontSize: "1.5rem" }} />
            </TableListButton>
            <TableListButton
              onClick={() => { handleDelete(config.id) }}
              title=""
              large
            >
              <i
                className="fa-solid fa-xmark"
                style={{
                  fontSize: "2rem",
                }}
              />
            </TableListButton>
          </div>
        </div>
      </CardContainer>
    ))}
  </>
}